import { useState, useEffect, Fragment } from 'react';
import api from '../../services/api'
import {
    Dialog, DialogContent, DialogActions, Button, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction,
    Divider, Avatar, TextField, Checkbox, Radio, InnerLoading
} from '../core'
import { AlertDialog } from './Dialog'

export const UserSelect = (props) => {

    /* Props
    open (Boolean) default false - Show UserSelect
    cancelButton (Boolean) default true - Hide/Show cancel button
    labelConfirmButton (String) default 'Selecionar' - Change label of confirm button
    handleClose (function) - Handle Close
    handleSelected (function) - Handle Selected(s) user(s)
    multiSelect (Boolean) - default false - Allow multi select users
    */

    const { open = false, cancelButton = true, labelConfirmButton = 'Selecionar', handleClose, multiSelect = false, handleSelected } = props
    const [users, setUsers] = useState([])
    const [query, setQuery] = useState('')
    const [loading, setLoading] = useState(false)
    const [selectedValue, setSelectedValue] = useState({ id: null });
    const [selectedItems, setSelectedItems] = useState([]);
    const [alert, setAlert] = useState({
        show: false,
        errors: [{ message: 'Ocorreu um erro' }],
    });

    const getUserId = (user) => user.id || user._id

    useEffect(() => {
        if (!open) {
            setQuery('')
            setUsers([])
            setSelectedValue({ id: null })
            setSelectedItems([])
            return
        }
    }, [open])

    useEffect(() => {
        if (!open) return

        const trimmedQuery = query.trim()
        if (!trimmedQuery) {
            setUsers([])
            setLoading(false)
            return
        }

        const timer = setTimeout(() => {
            setLoading(true)
            api.get(`/admin/users?q=name:like:${trimmedQuery}&page=1&per_page=20`)
                .then(res => {
                    setUsers(res.data.users || [])
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    const errors = err.response?.data?.errors || [{ message: 'Ocorreu um erro ao buscar usuários' }]
                    setAlert({ errors, show: true })
                })
        }, 300)

        return () => clearTimeout(timer)
    }, [query, open])

    const handleChange = (selectedValue) => {
        setSelectedValue(selectedValue);
    };

    const handleCheckBoxChange = (event, item) => {
        const { checked } = event.target
        const itemId = getUserId(item)

        if (checked) {
            setSelectedItems([
                ...selectedItems,
                item
            ])
        } else {
            setSelectedItems(selectedItems.filter((value) => getUserId(value) !== itemId))
        }
    };

    const handleQueryChange = ({ target }) => {
        setQuery(target.value)
    };

    const isSelected = (item) => selectedItems.some((selected) => getUserId(selected) === getUserId(item))

    const emptyMessage = !query.trim()
        ? 'Digite o nome do usuário para buscar'
        : 'Nenhum usuário encontrado'

    return (
        <Dialog
            open={open}
            maxWidth='sm'
            fullWidth
        >
            <AlertDialog
                open={alert.show}
                handleClose={() => setAlert({ ...alert, show: false })}
                errors={alert.errors}
            />
            <DialogContent dividers>
                <TextField
                    placeholder='Digite o nome do responsável'
                    fullWidth
                    value={query}
                    onChange={handleQueryChange}
                    autoFocus
                />
            </DialogContent>
            <DialogContent dividers style={{ position: 'relative', minHeight: 120 }}>
                {loading && <InnerLoading />}
                {!loading && users.length === 0 && (
                    <List dense>
                        <ListItem>
                            <ListItemText primary={emptyMessage} />
                        </ListItem>
                    </List>
                )}
                {!loading && users.length > 0 && (
                    <List dense>
                        {users.map((item) => (
                            <Fragment key={getUserId(item)}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt={item.name} src={item.avatar} />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={item.name}
                                        secondary={item.email}
                                    />
                                    {multiSelect ?
                                        <ListItemSecondaryAction>
                                            <Checkbox
                                                edge="end"
                                                checked={isSelected(item)}
                                                onChange={(event) => handleCheckBoxChange(event, item)}
                                            />
                                        </ListItemSecondaryAction>
                                        :
                                        <Radio
                                            checked={getUserId(selectedValue) === getUserId(item)}
                                            onChange={() => handleChange(item)}
                                            value={getUserId(item)}
                                            name="radio-option"
                                        />}
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </Fragment>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                {cancelButton &&
                    <Button onClick={handleClose} color="secondary">
                        Cancelar
                    </Button>
                }
                <Button onClick={() => handleSelected(multiSelect ? selectedItems : selectedValue)} color="primary" variant='contained'>
                    {labelConfirmButton}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
